import { Button, ColorCode } from '@vinted/web-ui';
import { useCallback } from 'react';
import { USER_FAVOURITE_ITEMS_URL } from 'constants/routes';
import useTranslate from 'hooks/useTranslate';
import useUserStats from 'hooks/useUserStats';
import HeaderConversations from './HeaderConversations';
import HeaderNotifications from './HeaderNotifications';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const HeaderUserActions = () => {
  const translate = useTranslate('header');
  const {
    userStats,
    fetchUserStats
  } = useUserStats();
  const {
    unreadMsgCount: unreadConversationCount = 0,
    unreadNotificationCount = 0
  } = userStats !== null && userStats !== void 0 ? userStats : {};
  const handleNotificationsFetched = useCallback(() => {
    if (unreadNotificationCount > 0) fetchUserStats();
  }, [unreadNotificationCount, fetchUserStats]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/_jsx(HeaderConversations, {
        unreadConversationCount: unreadConversationCount
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/_jsx(HeaderNotifications // When fetching the notifications, we tell the backend to mark ALL notifications as read.
      // To make sure that the stats reflect that, we refetch the stats *after* we fetch the notifications
      , {
        onNotificationsFetched: handleNotificationsFetched,
        unreadNotificationCount: unreadNotificationCount
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "user-actions__action",
      children: /*#__PURE__*/_jsx(Button, {
        deprecatedIconName: "heart",
        deprecatedIconColor: ColorCode.GreyscaleLevel4,
        styling: Button.Styling.Flat,
        url: USER_FAVOURITE_ITEMS_URL,
        aria: {
          'aria-label': translate('a11y.favorited_items')
        }
      })
    })]
  });
};

export default HeaderUserActions;